module.exports = __webpack_public_path__ + "static/media/intelligent_system_logo.5e789305.png";